import React, { Component, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Select from 'react-select';
import moment from 'moment';
import { channelActions } from '../../../_actions';
import { store } from '../../../_helpers';

import CellLogo from '../../../_assets/cell_logo_colored.png';
import DefaultNotificationImage from '../../../_assets/cell_notify_default.jpg';
import TopboxNotificationImage from '../../../_assets/cell_topbox_default.jpg';
import IconNotificationImage from '../../../_assets/cell_icon_default.jpg';

class CellModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			domain: "",
			domain_uuid: "",
			submitting: false,
			optinModel: {label: "Padrão", value: "DefaultNotification"}
		}

		this.closeModal = React.createRef();

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	async componentDidMount() {
		let domain = sessionStorage.getItem('selected_domain');
		if ( !domain ) return;

		await this.setState({
			domain: JSON.parse(domain).domain,
			domain_uuid: JSON.parse(domain).uuid
		});
	}

	handleChange(e) {
		this.setState({optinModel: e});
	}

	async handleSubmit(e) {
		e.preventDefault();
		
		const { dispatch } = this.props;
		this.setState({submitting: true});

		let options = {
			"channel": {
				"domain_uuid": this.state.domain_uuid,
				"channel_type": "CELL_NOTIFICATION",
				"properties": {}
			}
		}

		await dispatch(channelActions.create(options)).then(res => {
			this.setState({submitting: false});

			if ( res.type === "CHANNEL_INTEGRATION_FAILURE" ) {
				return toast.error(res.data.message, {
					position: toast.POSITION.TOP_RIGHT,
					className: 'toast-error'
				});
			}

			this.closeButton.current.click();
			return toast.success("Canal integrado com sucesso!", {
				position: toast.POSITION.TOP_RIGHT,
				className: 'toast-success'
			})
		});
	}

	render() {
		const { name } = this.props;
		const { domain, submitting } = this.state;

		return (
			<div className="modal fade" id={name + "Modal"} tabIndex="-1" role="dialog" aria-labelledby={name + "ModalLabel"} aria-hidden="true">
				<div className="modal-dialog modal-lg" role="document">
					<div className="modal-content">
						<div className="modal-body">
							<img src={CellLogo} alt="Logo da plataforma Cell em tons de azul e forma cúbica"/>
							<br/><br/>

							<button type="button" className="close" data-dismiss="modal" aria-label="Close" ref={this.closeModal}>
								<i className="lnr lnr-cross"></i>
							</button>

							{
								this.props.actionType !== "code" ?
									<>
										<p className="title">Adicionar canal Cell</p>
										<p className="disclaimer">Este canal habilitará a funcionalidade de <i>Push Notifications</i> em seu domínio <strong>{domain.charAt(0).toUpperCase() + domain.slice(1)}</strong>, podendo usar como forma de impacto na criação dos seus <i>Momentums</i>.</p>

										<form action="#" className="form clearfix" id="cellChannelForm" method="POST" onSubmit={this.handleSubmit}>
											{
												submitting ? 
													<button type="button" className="btn btn-blue float-right disabled" disabled>
														<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
														<span className="sr-only"> Integrando canal...</span>
													</button>
											: <button type="submit" className="btn btn-blue float-right">Adicionar</button>
											}
										</form>
									</>
								: <>
									<p className="title">Modelos de optin</p>
									<p className="disclaimer">Abaixo são mostrados exemplos de optin's disponíveis para o Canal Cell de notificações, ao selecionar o modelo, copie o código demonstrado e cole em sua página, alterando dados como título, descrição e URL da imagem em destaque.</p>

									<p className="field__title">Modelo:</p>
									<Select
										options={[
											{label: "Padrão", value: "DefaultNotification"},
											{label: "Caixa de topo", value: "TopboxNotification"}
											// {label: "Ícone", value: "IconNotification"}
										]}
										className="basic-select"
										classNamePrefix="select"
										placeholder="Selecione o modelo"
										onChange={this.handleChange}
										value={this.state.optinModel}
									/>

									{(() => {
										const Component = components[this.state.optinModel.value]
										return <Component />
									})()}
								</>
							}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const DefaultNotification = () => {
	const [ domain, setDomain ] = useState({})

	useEffect(() => {
		const domain = store.getState().changeDomainReducer.selectedDomain;
		setDomain({
			name: domain.domain_root,
			gero_id: domain.domain_gero_id
		})
	}, domain)

	return (
		<div style={{marginTop: "15px"}}>
			<p className="field__title">Exemplo:</p>
			<img className="img-responsive" src={DefaultNotificationImage} alt="Default notification image" />

			<p className="field__title">Código:</p>
			<pre className="code">
				<code>
					<span className="vsgr">{`<`}</span><span className="vsb">script</span><span className="vsgr">{`>`}</span><br />
					{`  `}<span className="vsb">var</span> <span className="vslb">gls</span> <span className="vsw">=</span> <span className="vslb">document</span>.<span className="vsly">createElement</span>(<span className="vso">"script"</span>);<br />
					{`  `}<span className="vslb">gls</span>.<span className="vslb">src</span> = <span className="vso">{`"https://personidkbr.com/static/files/gero_loader.min.js"`}</span>;<br />
					{`  `}<span className="vslb">gls</span>.<span className="vsly">onload</span> = <span className="vsb">function</span> () {`{`} <br />
					{`    `}<span className="vslb">GeroLoader</span>.<span className="vsly">init</span>{`({`}<br />
					{`      `}<span className="vslb">domain:</span> <span className="vso">{`".${domain.name}"`}</span>,<br />
					{`      `}<span className="vslb">gero_id:</span> <span className="vso">{`"${domain.gero_id}"`}</span><br />
					{`    `}{`});`}<br />
					{`  `}{`}`}<br />
					{`  `}<span className="vslb">document</span>.<span className="vslb">head</span>.<span className="vsly">appendChild</span>(<span className="vslb">gls</span>)<br />
					<span className="vsgr">{`</`}</span><span className="vsb">script</span><span className="vsgr">{`>`}</span><br />
				</code>
			</pre>
		</div>
	)
}

const TopboxNotification = () => {
	const [ domain, setDomain ] = useState({})

	useEffect(() => {
		const domain = store.getState().changeDomainReducer.selectedDomain;
		setDomain({
			name: domain.domain_root,
			gero_id: domain.domain_gero_id
		})
	}, domain)

	return (
		<div style={{marginTop: "15px"}}>
			<p className="field__title">Exemplo:</p>
			<img className="img-responsive" src={TopboxNotificationImage} alt="Default notification image" />

			<p className="field__title">Código:</p>
			<pre className="code">
			<code>
					<span className="vsgr">{`<`}</span><span className="vsb">script</span><span className="vsgr">{`>`}</span><br />
					{`  `}<span className="vsb">var</span> <span className="vslb">gls</span> <span className="vsw">=</span> <span className="vslb">document</span>.<span className="vsly">createElement</span>(<span className="vso">"script"</span>);<br />
					{`  `}<span className="vslb">gls</span>.<span className="vslb">src</span> = <span className="vso">{`"https://personidkbr.com/static/files/gero_loader.min.js"`}</span>;<br />
					{`  `}<span className="vslb">gls</span>.<span className="vsly">onload</span> = <span className="vsb">function</span> () {`{`} <br />
					{`    `}<span className="vslb">GeroLoader</span>.<span className="vsly">init</span>{`({`}<br />
					{`      `}<span className="vslb">domain:</span> <span className="vso">{`".${domain.name}"`}</span>,<br />
					{`      `}<span className="vslb">gero_id:</span> <span className="vso">{`"${domain.gero_id}"`}</span>,<br />
					{`      `}<span className="vslb">sw:</span> {`{`}<br />
					{`        `}<span className="vslb">disabled:</span> <span className="vsb">false</span>,<br />  
					{`        `}<span className="vslb">props:</span> {`{`}<br />  
					{`          `}<span className="vslb">type:</span> <span className="vso">"topbox"</span>,<br />
					{`          `}<span className="vslb">logo:</span> <span className="vso">"https://sua-url-de-imagem.com"</span>,<br />
					{`          `}<span className="vslb">content:</span> {`{`}<br />
					{`            `}<span className="vslb">title:</span> <span className="vso">"Título do optin customizado"</span>,<br />
					{`            `}<span className="vslb">description:</span> <span className="vso">"Descrição do seu optin customizado"</span><br />
					{`          `}{`}`}<br />
					{`        `}{`}`}<br />
					{`      `}{`}`}<br />
					{`    `}{`});`}<br />
					{`  `}{`}`}<br />
					{`  `}<span className="vslb">document</span>.<span className="vslb">head</span>.<span className="vsly">appendChild</span>(<span className="vslb">gls</span>)<br />
					<span className="vsgr">{`</`}</span><span className="vsb">script</span><span className="vsgr">{`>`}</span><br />
				</code>
			</pre>
		</div>
	)
}

const IconNotification = () => {
	const [ domain, setDomain ] = useState({})

	useEffect(() => {
		const domain = store.getState().changeDomainReducer.selectedDomain;
		setDomain({
			name: domain.domain_root,
			gero_id: domain.domain_gero_id
		})
	}, domain)

	return (
		<div style={{marginTop: "15px"}}>
			<p className="field__title">Exemplo:</p>
			<img className="img-responsive" src={IconNotificationImage} alt="Default notification image" />

			<p className="field__title">Código:</p>
			<pre className="code">
				<code>
					<span className="vsgr">{`<`}</span><span className="vsb">script</span><span className="vsgr">{`>`}</span><br />
					{`  `}<span className="vsb">var</span> <span className="vslb">gls</span> <span className="vsw">=</span> <span className="vslb">document</span>.<span className="vsly">createElement</span>(<span className="vso">"script"</span>);<br />
					{`  `}<span className="vslb">gls</span>.<span className="vslb">src</span> = <span className="vso">{`"https://personidkbr.com/static/files/gero_loader.min.js"`}</span>;<br />
					{`  `}<span className="vslb">gls</span>.<span className="vsly">onload</span> = <span className="vsb">function</span> () {`{`} <br />
					{`    `}<span className="vslb">GeroLoader</span>.<span className="vsly">init</span>{`({`}<br />
					{`      `}<span className="vslb">domain:</span> <span className="vso">{`".${domain.name}"`}</span>,<br />
					{`      `}<span className="vslb">gero_id:</span> <span className="vso">{`"${domain.gero_id}"`}</span>,<br />
					{`      `}<span className="vslb">optinConfiguration:</span> {`{`}<br />
					{`        `}<span className="vslb">type:</span> <span className="vso">"icon"</span>,<br />
					{`        `}<span className="vslb">logo:</span> <span className="vso">"https://sua-url-de-imagem.com"</span><br />
					{`      `}{`}`}<br />
					{`    `}{`});`}<br />
					{`  `}{`}`}<br />
					{`  `}<span className="vslb">document</span>.<span className="vslb">head</span>.<span className="vsly">appendChild</span>(<span className="vslb">gls</span>)<br />
					<span className="vsgr">{`</`}</span><span className="vsb">script</span><span className="vsgr">{`>`}</span><br />
				</code>
			</pre>
		</div>
	)
}

const components = {
	DefaultNotification,
	TopboxNotification,
	IconNotification
}

const mapStateToProps = (state) => {
  const { channelStatus } = state.createChannel;
  return channelStatus;
}

const ConnectedCellModal = connect(mapStateToProps)(CellModal);
export { ConnectedCellModal as CellModal }